export const events = {
  a3innuvaSettingsLogin: 'A3innuva settings login',
  a3innuvaSettingsLoginSuccessfully: 'A3innuva settings login successfully',
  a3innuvaSettingsAbsencesSelected: 'A3innuva settings absences selected',
  a3innuvaSettingsClientIdSelected: 'A3innuva settings client id selected',
  a3innuvaSettingsCompanySelected: 'A3innuva settings company selected',
  a3innuvaSettingsWorkplacesSelected: 'A3innuva settings workplaces selected',
  a3innuvaSettingsCompensationSelected: 'A3innuva settings compensation selected',
  a3innuvaSettingsNumberOfEducationLevelsMapped:
    'A3innuva settings number of education levels mapped',
  a3innuvaSettingsNumberOfContractTypesMapped: 'A3innuva settings number of contract types mapped',
  a3innuvaSettingsNumberOfCostCentersMapped: 'A3innuva settings number of cost centers mapped',
  a3innuvatSettingsJobPositionsSelected: 'A3innuva settings job positions selected',
}
